import { render } from "./SideBarItemComp.vue?vue&type=template&id=63d359ce&scoped=true"
import script from "./SideBarItemComp.vue?vue&type=script&lang=js"
export * from "./SideBarItemComp.vue?vue&type=script&lang=js"

import "./SideBarItemComp.vue?vue&type=style&index=0&id=63d359ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d359ce"]])

export default __exports__